export const mapCampaignStoreGroupIds = (storeGroupId) => {
  if (Array.isArray(storeGroupId)) {
    return storeGroupId
      .filter((value) => value !== null && value !== undefined && value !== "")
      .map((value) => String(value));
  }

  if (storeGroupId === null || storeGroupId === undefined || storeGroupId === "") {
    return [];
  }

  return [String(storeGroupId)];
};

export const toComparableId = (value) => String(value);

export const formatUtcDate = (value) => {
  if (!value) return "-";

  const normalized = String(value).trim();
  const datePart = normalized.match(/^\d{4}-\d{2}-\d{2}/)?.[0];

  if (datePart) {
    const [year, month, day] = datePart.split("-");
    return `${day}.${month}.${year}`;
  }

  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) {
    return "-";
  }

  const dd = String(parsed.getUTCDate()).padStart(2, "0");
  const mm = String(parsed.getUTCMonth() + 1).padStart(2, "0");
  const yyyy = String(parsed.getUTCFullYear());
  return `${dd}.${mm}.${yyyy}`;
};

export const getDateRangeText = (validFrom, validTo) => {
  return `${formatUtcDate(validFrom)} - ${formatUtcDate(validTo)}`;
};
